import Lottie from 'lottie-react';
import animationData from 'assets/lottie/stars-main.json';

export const StarsMain = () => {
  return <Lottie animationData={animationData} height={97} width={'100%'} loop autoplay />;
};
